import api from '@/plugins/api'
import Model from 'scomponent/src/data/model'
import fieldTranslation from '../../../.env.models.json'
import {
  confirmationPopup,
  generalError,
  generalSuccess,
} from '@/plugins/popups'

export class AddressModel extends Model {
  private static instance: AddressModel = new AddressModel()
  id: number = 0
  address: string = ''
  city: string = ''
  country: string = ''
  zipCode: string = ''
  isDefault: boolean = false

  public static getInstance(): AddressModel {
    this.instance.setTranslateField(fieldTranslation['Address'])
    return AddressModel.instance
  }

  deleteAddress(id: number, deleteCallback: any) {
    confirmationPopup(() => {
      api()
        .delete(`addresses/${id}`)
        .then(response => {
          if (response.status === 200) {
            generalSuccess()
            deleteCallback()
          }
        })
        .catch(() => {
          generalError()
        })
    })
  }

  createAddress(payload: any) {
    api()
      .post(`addresses`, payload)
      .then(response => {
        if (response.status === 200) {
          generalSuccess()
        }
      })
      .catch(() => {
        generalError()
      })
  }

  updateAddress(payload: any) {
    api()
      .put(`addresses/${payload.id}`, payload)
      .then(response => {
        if (response.status === 200) {
          generalSuccess()
        }
      })
      .catch(() => {
        generalError()
      })
  }

  updateAddressStatus(payload: any) {
    api()
      .put(`addresses/${payload.id}/default`, payload)
      .then(() => {})
      .catch(() => {
        generalError()
      })
  }
}
